module.exports = __webpack_public_path__ + "img/thumb_2021-06.cd57fca7.jpg";